module.exports = __webpack_public_path__ + "img/newsImg12-1.1431f7c9.png";